// @flow

import { defaultDataLayer } from '../../utils/TagManagerUtils';
import {
  GET_DATALAYER_REQUEST,
  GET_DATALAYER_SUCCESS,
  GET_DATALAYER_ERROR,
  CLEAR_TAG_MANAGER_RESPONSES,
  UPDATE_DATALAYER,
} from '../actions';
import type { TagManagerState, TagManagerActions, ApiState } from '../types';

const requestInitialState = (): ApiState<any, any, any> => ({
  loading: false,
  time: null,
  success: false,
  params: null,
  error: null,
  response: null,
});

export const initialState = {
  dataLayer: defaultDataLayer,
  getDataLayer: requestInitialState(),
};

export const tagManagerReducer = (
  state: TagManagerState = initialState,
  action: TagManagerActions,
): TagManagerState => {
  switch (action.type) {
    case GET_DATALAYER_REQUEST:
      return {
        ...state,
        getDataLayer: {
          loading: true,
          time: Date.now(),
          success: false,
          params: action.payload,
          error: null,
          response: null,
        },
      };
    case GET_DATALAYER_SUCCESS:
      return {
        ...state,
        getDataLayer: {
          ...state.getDataLayer,
          loading: false,
          time: null,
          success: true,
          error: null,
          response: action.payload,
        },
      };
    case GET_DATALAYER_ERROR:
      return {
        ...state,
        getDataLayer: {
          ...state.getDataLayer,
          loading: false,
          time: null,
          success: false,
          error: action.payload,
          response: null,
        },
      };
    case CLEAR_TAG_MANAGER_RESPONSES:
      return {
        ...state,
        getDataLayer: requestInitialState(),
      };
    case UPDATE_DATALAYER:
      return {
        ...state,
        dataLayer: action.payload,
      };
    default:
      return state;
  }
};
